module.exports = __webpack_public_path__ + "img/category-favorite-hover.7929490d.png";